import styled from 'styled-components'

export const Container = styled.div`
  margin-top: 62px;
  margin-left: 44px;
  margin-right: 44px;
  margin-bottom: 62px;
`
